import axios from "axios";

// Définition dynamique de l'URL backend
const BACKEND_URL =
  window.location.hostname === "localhost"
    ? process.env.REACT_APP_BACKEND_URL_LOCAL + "/api"
    : process.env.REACT_APP_BACKEND_URL_PROD + "/api";

export const getSocietes = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${BACKEND_URL}/societes`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (err) {
    console.error("Erreur lors de la récupération des sociétés :", err);
    return [];
  }
};